import { Component,Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { ChartDefinition } from 'src/shared/models/chart-definintions.model';
import { ReportService } from 'src/shared/services/report.service';
import { Observable, Subscription, from } from 'rxjs';
import { ReportData } from 'src/shared/models/report-data.model';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
  selector: 'smt-totaluostrendsreport',
  templateUrl: './total-uos-trends-report.component.html',
  styleUrls: ['./total-uos-trends-report.component.scss']
})
export class TotalUosTrendsReportComponent implements OnInit {
  reportData: ReportData;
  chartDefinition: ChartDefinition = new ChartDefinition();
  reportChart : Chart;
  loading:boolean;
  reportSubscription : Subscription;
  
  private filterEventSubscription: Subscription;
  @Input() filtersUpdated: Observable<void>;
  @Input() reportFilters:ReportFilters;

  @Output() dataUpdated = new EventEmitter();

  constructor(private _reportService:ReportService) { }

  ngOnInit() {
    this.drawEmpty();
    this.loading = true;
    if(this.filtersUpdated)
      this.filterEventSubscription = this.filtersUpdated.subscribe(() => this.getData());
  }

  drawEmpty()
  {
    this.reportChart = this.chartDefinition.getColumnTemplate(
      '',
      '' ,
      'UOS Totals',
      [] 
    );
  }

  drawGrid()
  {
    this.loading = false;

    if (!this.reportData)
      return;

    let chartData = MiscUtil.getDataFilteredByDataSetName(this.reportData);

    this.reportChart = this.chartDefinition.getColumnTemplate(
      this.getTitle(),
      this.reportFilters.ReportView,
      'UOS Totals',
      this.reportData.xAxis
    );

    if (chartData.length == 0)
      return;

    let chartSizeMinusOne = chartData.length - 1;

    // Add all but the last entry with the re-draw flag set to false this speeds up chart drawing
    chartData.slice(0,chartSizeMinusOne).forEach(dataSet =>
      {
        this.reportChart.addSeries({type: 'line', name: dataSet.name, data: dataSet.data}, false, true);
      });

    this.reportChart.addSeries({type: 'line', name: chartData[chartSizeMinusOne].name, data: chartData[chartSizeMinusOne].data}, true, true);
  }

  getTitle()
  {
    var title = 'Total UOS Trends'; 
    return title;
  }

  async getData()
  {

    this.loading = true;

    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();

    this.reportSubscription = from(this._reportService.getTotalUosTrendsReport(this.reportFilters))
                                                      .subscribe(x =>
                                                      {
                                                        this.reportData = x ;
                                                        this.dataUpdated.emit(this.reportData);
                                                        this.drawGrid();
                                                      });
  }

  ngOnDestroy() {
    if(this.filtersUpdated)
      this.filterEventSubscription.unsubscribe();
    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();
}


}
